import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface CollectionRegistrationInfo {
  branchCode: SystemCode
  holdingCount: number
  orderCount: number
  traderEnvVendorId: number
  acceptType: SystemCode
  acceptPrice: number
  buyDepartmentCode: SystemCode
  donorEnvVendorId: number
  budgetYear: string
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetExpenseCode: SystemCode
  equipType: SystemCode
  collectionType: SystemCode
}

export function CollectionRegistrationInfoFromJSON(
  json: any
): CollectionRegistrationInfo {
  return {
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    holdingCount: exists(json, 'holding_count') ? json.holding_count : 0,
    orderCount: exists(json, 'order_count') ? json.order_count : 0,
    traderEnvVendorId: exists(json, 'trader_env_vendor_id')
      ? json.trader_env_vendor_id
      : 0,
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    acceptPrice: exists(json, 'accept_price') ? json.accept_price : 0,
    buyDepartmentCode: exists(json, 'buy_department_code')
      ? SystemCodeFromJSON(json.buy_department_code)
      : defaultSystemCode(),
    donorEnvVendorId: exists(json, 'donor_env_vendor_id')
      ? json.donor_env_vendor_id
      : 0,
    budgetYear: exists(json, 'budget_year') ? json.budget_year : '',
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetExpenseCode: exists(json, 'budget_expense_code')
      ? SystemCodeFromJSON(json.budget_expense_code)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode()
  }
}
